import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { NBAuthGuard } from "./AuthGuard";
import { AuthRoutes } from "./AuthRoutes";
import { OnboardRoutes } from "./OnboardRoutes";
import { UserRoutes } from "./UserRoutes";
import { BrandExpoScreen } from "../screens/BrandExpo.screen";
import { GraphqlExpoScreen } from "../screens/GraphqlExpo.screen";
import { TenantRoutes } from "./TenantRoutes";
const SpaRouter = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/auth/*",
    element: /*#__PURE__*/React.createElement(AuthRoutes, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/onboard/*",
    element: /*#__PURE__*/React.createElement(OnboardRoutes, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/tenant/*",
    element: /*#__PURE__*/React.createElement(TenantRoutes, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/user/*",
    element: /*#__PURE__*/React.createElement(NBAuthGuard, null, /*#__PURE__*/React.createElement(UserRoutes, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/brandExpo",
    element: /*#__PURE__*/React.createElement(BrandExpoScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/graphqlExpo",
    element: /*#__PURE__*/React.createElement(GraphqlExpoScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    element: /*#__PURE__*/React.createElement(NBAuthGuard, null, children)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/",
      replace: true
    })
  })));
};
export { SpaRouter };